export * from './addon-automation-price';
